// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"68c05c15","231":"758fc78b","511":"44ee07ef"}[chunkId] + ".chunk.css";
};